/**
 * One sizing contract for every dialog in the panel.
 *
 * Previously each view sized its own Modal with a percentage width and a
 * matching left margin ('65%' + '18%', '75%' + '13%', …), so dialogs landed at
 * different widths, drifted off-centre on wide screens and could not scroll
 * when their form was taller than the viewport.
 *
 * `modalOverlay` goes on the Modal itself: a full-screen, scrollable, centred
 * container. `modalCard` goes on a Box wrapping the dialog body and caps how
 * wide it can grow — `size` picks the cap.
 */
export const modalOverlay = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  padding: '32px 16px',
  overflowY: 'auto'
}

const WIDTHS = {
  sm: 480,
  md: 720,
  lg: 960,
  xl: 1140
}

export const modalCard = (size = 'md') => ({
  width: '100%',
  maxWidth: WIDTHS[size] || WIDTHS.md,
  margin: '0 auto',
  outline: 'none',
  // The card keeps its own scrollbar so a long form never pushes the dialog
  // past the bottom of the screen.
  maxHeight: 'calc(100vh - 64px)',
  overflowY: 'auto',
  // Round the scroll box to the card inside it and drop the card's own
  // bottom margin, so the scrollbar sits within the card's edge instead of
  // running past its corners and down a grey strip beneath it.
  borderRadius: '18px',
  '& > *': { marginBottom: '0 !important' },
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': { width: 8 },
  '&::-webkit-scrollbar-track': { background: 'transparent', margin: '14px 0' },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(16,24,40,0.18)',
    borderRadius: 8
  }
})

export default modalCard
